import { render, staticRenderFns } from "./register-myinfo-callback.vue?vue&type=template&id=b6de3306&"
import script from "./register-myinfo-callback.vue?vue&type=script&lang=js&"
export * from "./register-myinfo-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports